import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-twitch', 'BrandTwitch', [["path",{"d":"M15.556 11.1V7.5M20 3H4v14.4h4.444V21L12 17.4h4.444L20 13.8zm-8.889 8.1V7.5z","key":"svg-0"}]]);